import React from 'react';
import { createPortal } from 'react-dom';
import { useAuth } from '../context/AuthContext';

const SessionTimeoutWarning = () => {
  const { showIdleWarning, extendSession, logout } = useAuth();

  if (!showIdleWarning) return null;

  const handleExtendSession = () => {
    extendSession();
  };

  const handleLogoutNow = () => {
    logout('manual');
  };

  return createPortal(
    <div className="app-modal-layer bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white dark:bg-gray-800 rounded-lg p-6 max-w-md w-full mx-4 shadow-xl">
        <div className="flex items-center mb-4">
          <div className="flex-shrink-0">
            <svg className="w-6 h-6 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 19.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <div className="ml-3">
            <h3 className="text-lg font-medium text-gray-900 dark:text-white">
              会话即将过期
            </h3>
          </div>
        </div>
        
        <div className="mb-6">
          <p className="text-sm text-gray-600 dark:text-gray-300 mb-2">
            由于长时间无操作，您的会话即将过期。
          </p>
          <p className="text-sm text-gray-600 dark:text-gray-300">
            请选择继续使用或立即退出。
          </p>
        </div>
        
        <div className="flex space-x-3">
          <button
            onClick={handleExtendSession}
            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-md transition duration-200"
          >
            继续使用
          </button>
          <button
            onClick={handleLogoutNow}
            className="flex-1 bg-gray-300 hover:bg-gray-400 dark:bg-gray-600 dark:hover:bg-gray-500 text-gray-700 dark:text-gray-200 font-medium py-2 px-4 rounded-md transition duration-200"
          >
            立即退出
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default SessionTimeoutWarning;
